import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';

interface ReasonerParams {
  conversationId?: string;
  scrollTo?: string;
  mode?: string;
}

export const useReasonerParams = () => {
  const { params, setQueryParams, deleteQueryParam } =
    useQueryParams<Record<keyof ReasonerParams, string>>();

  const setReasonerParams = (params: ReasonerParams) => {
    setQueryParams({
      [queryKeys.conversationId]: params.conversationId,
      [queryKeys.mode]: 'research',
      [queryKeys.scrollTo]: params.scrollTo,
    });
  };

  return {
    conversationId: params.conversationId ?? '',
    mode: params.mode,
    scrollTo: params.scrollTo,
    setReasonerParams,
    deleteReasonerConversationId: () =>
      deleteQueryParam(queryKeys.conversationId),
  };
};
